import { pb } from "./pocketbase";

export const inventoryService = {
  // --- 1. IMPORTAR ITENS ---
  async importItems(items, userName = "Conferência") {
    if (!items || items.length === 0) return 0;

    // PocketBase não tem batch real para create, fazemos Promise.all
    // Dica Pro: Para volumes gigantes (1000+), ideal fazer em chunks de 50.
    const promises = items.map((item) => {
      return pb.collection("inventory_items").create({
        sku: item.sku,
        baseSku: item.baseSku || item.sku,
        status: "in_stock",
        addedBy: userName,
        isPE: false, // Default: Item de Estoque Físico
        // PocketBase gera created/updated automatico
        dateIn: item.dateIn ? new Date(item.dateIn).toISOString() : new Date().toISOString(),
        dateOut: null,
        source: "conference_scan",
      });
    });

    await Promise.all(promises);
    return items.length;
  },

  // --- 2. AJUSTAR ESTOQUE (Botões + e -) ---
  async adjustQuantity(sku, delta, userName = "Sistema") {
    if (delta > 0) {
      // ADICIONAR (LOOP CREATE)
      const promises = [];
      for (let i = 0; i < delta; i++) {
        promises.push(
          pb.collection("inventory_items").create({
            sku: sku,
            baseSku: sku,
            status: "in_stock",
            addedBy: userName,
            isPE: false,
            dateIn: new Date().toISOString(),
            reason: "manual_adjustment",
          })
        );
      }
      await Promise.all(promises);
    } else {
      // REMOVER (GET -> UPDATE)
      const qtyToRemove = Math.abs(delta);

      // Busca itens disponiveis (FIFO - First In First Out pelo 'created')
      // sort: "+created" (mais antigo primeiro)
      const items = await pb.collection("inventory_items").getList(1, qtyToRemove, {
        filter: `sku="${sku}" && status="in_stock"`,
        sort: "+created",
      });

      if (items.items.length < qtyToRemove) {
        throw new Error("Estoque insuficiente.");
      }

      const updatePromises = items.items.map((item) =>
        pb.collection("inventory_items").update(item.id, {
          status: "adjusted_out",
          removedBy: userName,
          dateOut: new Date().toISOString(),
        })
      );

      await Promise.all(updatePromises);
    }
  },

  // --- 3. VENDA EM LOTE ---
  async sellItems(skuList, userName = "Venda") {
    if (!skuList || skuList.length === 0) return;

    // Agrupa contagem: { "ANEL-01": 2, "BRINCO": 1 }
    const counts = {};
    skuList.forEach((sku) => (counts[sku] = (counts[sku] || 0) + 1));

    // Processa SKU por SKU (Para garantir integridade por item)
    for (const [sku, qty] of Object.entries(counts)) {
      // Busca X itens disponiveis desse SKU
      const availableItems = await pb
        .collection("inventory_items")
        .getList(1, qty, {
          filter: `sku="${sku}" && status="in_stock"`,
          sort: "+created",
        });

      // Atualiza status para 'sold'
      const updatePromises = availableItems.items.map((item) =>
        pb.collection("inventory_items").update(item.id, {
          status: "sold",
          soldBy: userName,
          dateOut: new Date().toISOString(),
        })
      );

      // Não bloqueia erro se faltar um, tenta vender o que achou
      await Promise.all(updatePromises);
    }

    return skuList.length;
  },

  // --- 4. CRIAR RESERVA ---
  async createReservation(sku, quantity, userName, note, customerName) {
    let legacyNote = note || "";
    if (customerName) {
      legacyNote = legacyNote
        ? `${customerName} - ${legacyNote}`
        : customerName;
    }

    // ADAPTER: Preenchemos tanto os campos novos (flat) quanto o JSON legado
    // para garantir compatibilidade total com o Frontend atual.
    await pb.collection("reservations").create({
      sku: sku,
      quantity: Number(quantity),
      created_by_name: userName, // Novo
      createdBy: userName, // Legado (se o front usar, vai no payload mas PB ignora se n tiver coluna, entao ok)
      notes: legacyNote,
      customer_name: customerName, // Novo (Flat)
      isManualReservation: true,
      status: "PENDENTE", // Padronizado conforme análise

      // JSON Legado Completo
      order_metadata: {
        customer: {
          name: customerName || "Cliente Reserva",
        },
      },
    });
  },

  // --- 5. EXCLUIR ITEM INDIVIDUAL ---
  async deleteItem(itemId, isPE, userName) {
    console.log(`InventoryService: Deletando ${itemId}. Modo PE: ${isPE}`);

    if (isPE) {
      // Se for PE, deleta fisicamente do banco
      await pb.collection("inventory_items").delete(itemId);
    } else {
      // Se for Estoque Físico, baixa logicamente
      await pb.collection("inventory_items").update(itemId, {
        status: "adjusted_out",
        dateOut: new Date().toISOString(),
        removedBy: userName || "Sistema",
        reason: "manual_deletion_modal",
      });
    }
  },

  // --- 6. EXCLUIR EM LOTE (Para StockTab) ---
  async deleteBatch(items, userName) {
    // items: Array de objetos { id, isPE }
    const promises = items.map(item => this.deleteItem(item.id, item.isPE, userName));
    await Promise.all(promises);
  },

  // --- HELPERS (Compatibilidade) ---
  // Se houver algum método extra que o código chama, adicione aqui. 
  // Por enquanto, esses 5 cobrem a interface original analisada.
};
